<template>
  <span>
    <div class="alert alert-warning" v-if="notificationText">
{{ notificationText }}
    </div>
  </span>
</template>

<script>

import {
  getNotifications,  
} from "@/services/APIService";

export default {
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    getNotifications().then((notifications) => {
          this.notifications = notifications;
        });
  },
  computed: {
    notificationText() {
      for (let i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].locale === this.$i18n.locale) {
          return this.notifications[i].notification_text
        }
      }
      return null;
    }
  },
};
</script>
